module.exports = __webpack_public_path__ + "img/ico-check-blue1.3f59f251.svg";